import { UsersIcon, Building2Icon, DownloadIcon, ClockIcon, type LucideIcon } from 'lucide-react';

export interface SocialStat {
  icon: LucideIcon;
  value: string;
  label: string;
  colorClass: string;
}

export const socialStats: SocialStat[] = [
  { icon: UsersIcon, value: '+9K', label: 'Entrenadores activos', colorClass: 'text-azul' },
  { icon: Building2Icon, value: 'Más de 1.000', label: 'Clubes y Colegios', colorClass: 'text-marino' },
  { icon: DownloadIcon, value: '+150.000', label: 'Descargas del sistema', colorClass: 'text-naranja' },
  { icon: ClockIcon, value: '+4 horas', label: 'Ahorradas / semana', colorClass: 'text-azul' }
];
